import React from 'react';
import {
  HighlightText,
  type ItemTemplateParams,
  SelectroController,
} from '@aha-app/selectro-v2';
import UserAvatar from './components/UserAvatar';
import { useController, ApplicationView as view } from '@aha-app/mvc';

const UserItemTemplate: React.FC<ItemTemplateParams> = ({ item, tabIndex }) => {
  const controller = useController(SelectroController);
  const skipAvatar = [
    '__EMPTY__',
    '__NON_EMPTY__',
    '__NON_SELECTABLE__',
    '',
  ].includes(item.value);
  const showAvatar = item.data?.show_avatar ?? true;

  return (
    <div
      className='SelectroV2__text tw-flex tw-justify-between'
      data-testid='item-user-template'
      tabIndex={item.disabled ? -1 : tabIndex}
    >
      <div className='tw-flex tw-items-center tw-gap-1 tw-flex-wrap'>
        {!skipAvatar && showAvatar && (
          <UserAvatar
            onlyAvatar
            avatar={item.data.avatar}
            text={item.text}
            initials={item.data.initials}
          />
        )}
        <div>
          <HighlightText item={item} text={item.text} />
        </div>
        {item.data.email && controller.state.searchQuery ? (
          <div>
            (<HighlightText item={item} text={item.data.email} />)
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default view(UserItemTemplate);
